export enum RESOURCES {
	SESSION = 'session',
	DOWNLOAD = 'download',
	SHARE = 'share',
	PATIENT_HISTORY = 'patientHistory',
	STUDY = 'study',
	PRINTER = 'printer',
	PRINT = 'print',
}
